import { useLocalStorage } from "@/auth/localStorage.tsx";
import { ZarazEvents } from "@/utils/zaraz-events";
import { useEffect, useState } from "react";
import { Navigate, useSearchParams } from "react-router-dom";

const Callback = () => {
  const [searchParams] = useSearchParams();
  const [, setTokenInStorage] = useLocalStorage("token");
  const [saving, setSaving] = useState(true);
  const token = searchParams.get("token");
  const isCLILogin = searchParams.get("is-cli-login") === "true";
  useEffect(() => {
    setTokenInStorage(token);
    window.zaraz.track(
      searchParams.get("isSignUp") === "true"
        ? ZarazEvents.SIGNUP_SUCCESS
        : ZarazEvents.LOGIN_SUCCESS,
      { provider: localStorage.getItem("lastUsedAuthnProvider") }
    );
    window.location.reload();
    setSaving(false);
  }, [searchParams, setTokenInStorage]);
  return saving ? <p>Verifying...</p> : <Navigate to={isCLILogin ? "/authn/cli" : "/"} />;
};

export default Callback;
